import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=9767df02&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=9767df02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9767df02",
  null
  
)

export default component.exports